import { render, staticRenderFns } from "./DonationButton.vue?vue&type=template&id=78d7dcf4&scoped=true"
import script from "./DonationButton.vue?vue&type=script&setup=true&lang=js"
export * from "./DonationButton.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DonationButton.vue?vue&type=style&index=0&id=78d7dcf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d7dcf4",
  null
  
)

export default component.exports